var React = require('react');

function IconChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.2436 6.80511L31.4849 21.0464C32.1717 21.7332 32.1717 22.8468 31.4849 23.5336L29.8238 25.1946C29.1382 25.8802 28.0269 25.8816 27.3396 25.1975L16 13.9111L4.66039 25.1976C3.9731 25.8816 2.86182 25.8803 2.17615 25.1947L0.515134 23.5336C-0.171711 22.8468 -0.171711 21.7332 0.515134 21.0465L14.7564 6.80518C15.4432 6.11834 16.5567 6.11834 17.2436 6.80511Z"}));
}

IconChevronUp.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"currentColor"};

module.exports = IconChevronUp;

IconChevronUp.default = IconChevronUp;
